export const getMintingInterface = (contractVersion: string, minterType: string | null) => {
  return null
}
